import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { savedViews } }: ComposedTheme) => {
  const { menu } = savedViews;
  return {
    root: {
      padding: [4, 16],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: 300,
      height: 32,
      '& input': {
        height: 32,
      },
    },
    defaultRoot: {
      '&:hover, &:focus-within': {
        background: menu.hoverColor,
      },
    },
    viewButton: {
      fontFamily: menu.text.font.fontFamily,
      fontSize: menu.text.font.fontSize,
      fontWeight: menu.text.font.fontWeight,
      color: menu.text.color,
      textDecoration: 'none',
      width: '100%',
      height: '100%',
      textAlign: 'left',
      '&:hover, &:focus': {
        textDecoration: 'none',
        outline: 'none',
      },
    },
    defaultText: {
      fontFamily: menu.default.font.fontFamily,
      fontStyle: menu.default.font.fontStyle,
      fontSize: menu.default.font.fontSize,
      fontWeight: menu.default.font.fontWeight,
      color: menu.default.color,
    },
    rightSide: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    popover: {
      padding: [8, 0],
    },
    actionsButton: {
      marginLeft: 8,
      background: 'transparent',
    },
    control: {
      fontFamily: menu.text.font.fontFamily,
      fontSize: menu.text.font.fontSize,
      fontWeight: menu.text.font.fontWeight,
      display: 'block',
      padding: 8,
      color: menu.text.color,
      width: '100%',
      textAlign: 'left',
      '&:hover': {
        background: menu.hoverColor,
      },
      '&:hover, &:focus': {
        textDecoration: 'none',
      },
    },
    deleteRoot: {
      color: savedViews.text.color,
      '& p': {
        margin: 0,
      },
      '& > div': {
        display: 'flex',
        alignItems: 'center',
      },
      '& svg': {
        fill: savedViews.deleteWarningIconColor,
        marginRight: 8,
      },
    },
    noButton: {
      marginLeft: 8,
      paddingLeft: 8,
      borderLeft: `${menu.noBorderColor} 1px solid`,
    },
    renameForm: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& label': {
        margin: 0,
      },
      '& > div': {
        marginLeft: 20,
      },
    },
    deleteText: savedViews.delete.text,
  };
};

export default createUseStyles(styles);
